import BasicModal from '../../components/shared/modals/BaseModal'
import React, { useState, useEffect } from 'react'
import {
  IconButton,
  Grid,
  Button,
  Box,
  CircularProgress,
  Tooltip,
  styled
} from '@mui/material'
import { object, func } from 'prop-types'
import { RemoveRedEye, FileDownload } from '@mui/icons-material'
import PrivateRC from '../../components/PrivateRC'
import AdaptativeGridContainer from '../../components/shared/AdaptativeGridContainer'
import { Postagens, Logs } from '../../services/http'
import { notification } from '../../services/notification'
import SmallTextField from '../../components/textfield/SmallTextfield'
import BaseDatePicker from '../../components/shared/BaseDatePicker'
import Swal from 'sweetalert2'

const StyledVideo = styled('video')(() => ({
  width: '100%',
  maxHeight: '400px',
  backgroundColor: '#000'
}))

export default function VisualizarPostagemModal({
  postagem,
  onChange = () => {}
}) {
  const OpenButton = ({ ...props }) => {
    return (
      <IconButton color="leitura" {...props}>
        <RemoveRedEye />
      </IconButton>
    )
  }

  const putPostagem = async form => {
    await Postagens(postagem.id).update(form)
    postLog(
      `[EDIT] Mudou período para ${form.mes_id}/${form.ano_id}. RESUMO ID: ${postagem.id} - Tela: Visualizar Resumo`
    )
    notification(form.message, form.typeMessage)
    onChange()
  }

  const postLog = async message => {
    await Logs().store({ acoes: message })
  }

  const [status, setStatus] = useState(false)
  const [loading, setLoading] = useState(true)
  const [urlVideo, setUrlVideo] = useState('')
  const [downloading, setDownloading] = useState(false)
  const [date, setDate] = useState(null)

  const getVideo = async () => {
    const { data } = await Postagens(postagem.id).video().show()
    setUrlVideo(data.downloadUrl)
    setLoading(false)
  }

  const downloadVideoFilename = () => {
    if (!postagem.pathVideo) return `postagem-${postagem.id}.mp4`
    return postagem.pathVideo.split('/').pop()
  }

  const handleDownloadVideo = async () => {
    setDownloading(true)
    try {
      const response = await fetch(urlVideo)
      const blob = await response.blob()
      const blobUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = downloadVideoFilename()
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(blobUrl)
    } catch (error) {
      notification('Não foi possível baixar o vídeo', 'error')
    } finally {
      setDownloading(false)
    }
  }

  const fieldDataChange = async value => {
    await Swal.fire({
      title: 'Deseja alterar o período do Resumo?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      if (result.isConfirmed) {
        const newDate = new Date()
        newDate.setFullYear(value?.$y)
        newDate.setMonth(value?.$M)
        setDate(newDate)
        putPostagem({
          mes_id: value?.$M + 1,
          ano_id: value?.$y,
          message: 'Período alterado',
          typeMessage: 'success'
        })
      }
    })
  }

  useEffect(() => {
    if (status === true && postagem.pathVideo !== null) {
      getVideo()
    }
    if (status === false) {
      setUrlVideo('')
    }
  }, [status])

  useEffect(() => {
    const newDate = new Date()
    if (!date) {
      newDate.setFullYear(postagem.ano)
      newDate.setMonth(postagem.mes - 1)
    }
    setDate(newDate)
  }, [postagem])

  return (
    <BasicModal
      title="Visualizar Postagem"
      sx={{ width: { xs: '100vw', md: '60vw' } }}
      status={status}
      Caller={OpenButton}
      closeEvent={event => setStatus(event)}
    >
      <>
        <AdaptativeGridContainer
          sx={{ justifyContent: 'space-between' }}
          rowSpacing={2}
        >
          <>
            <Grid
              item
              xs={12}
              md={10}
              lg={10}
              sx={{
                pt: '0px !important',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <h3>{postagem.livro}</h3>
            </Grid>
            <PrivateRC roles="gestor">
              <Grid
                item
                xs={12}
                md={3}
                lg={3}
                sx={{
                  pt: '20px !important',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <BaseDatePicker
                  inputFormat="MM/YYYY"
                  mask="__/____"
                  openTo="month"
                  views={['year', 'month']}
                  label="Período"
                  value={date}
                  onChange={fieldDataChange}
                  clearable={true}
                />
              </Grid>
            </PrivateRC>
            {/* ///////////////////////////// */}
            {/* <Grid
              item
              xs={12}
              md={1}
              lg={1}
              sx={{
                pt: '0px !important',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <h4>{`${postagem.mes}/${postagem.ano}`}</h4>
            </Grid> */}
            {/* /////////////////////////////// */}
            <Grid item xs={12} md={12} lg={12}>
              <SmallTextField
                variant="filled"
                disabled
                label="Quais conteúdos deste livro podem ser aplicados de imediato em sua vida?"
                value={postagem.conteudoAplicadoVida}
              />
            </Grid>

            <Grid item xs={12}>
              {postagem.resumo ? (
                <SmallTextField
                  variant="filled"
                  disabled
                  multiline
                  minRows={12}
                  maxRows={12}
                  value={postagem.resumo}
                />
              ) : (
                <>
                  {loading ? (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '400px'
                      }}
                    >
                      <CircularProgress size={70} />
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        backgroundColor: '#000'
                      }}
                    >
                      <StyledVideo controls autoPlay src={urlVideo} />
                    </Box>
                  )}
                </>
              )}
            </Grid>
            {/* //////////////////////// Ações //////////////////////// */}
            <PrivateRC roles="gestor">
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'flex-end',
                    gap: 2,
                    mt: 2
                  }}
                >
                  {urlVideo && (
                    <Tooltip title="Baixar vídeo">
                      <Button
                        color="leitura"
                        variant="outlined"
                        disabled={downloading}
                        onClick={handleDownloadVideo}
                        startIcon={
                          downloading ? (
                            <CircularProgress size={16} />
                          ) : (
                            <FileDownload />
                          )
                        }
                      >
                        Baixar vídeo
                      </Button>
                    </Tooltip>
                  )}
                  <Button
                    disabled={postagem.statusRh === 3}
                    variant="contained"
                    color="error"
                    onClick={() => {
                      putPostagem({
                        status_postagem_id: 3,
                        message: 'Resumo Reprovado',
                        typeMessage: 'warning'
                      })
                      setStatus(false)
                    }}
                  >
                    Reprovar
                  </Button>
                  <Button
                    disabled={postagem.statusRh === 2}
                    variant="contained"
                    color="success"
                    onClick={() => {
                      putPostagem({
                        status_postagem_id: 2,
                        message: 'Resumo Aprovado',
                        typeMessage: 'success'
                      })
                      setStatus(false)
                    }}
                  >
                    Aprovar
                  </Button>
                </Box>
              </Grid>
            </PrivateRC>
            {/* //////////////////////////////////////// */}
          </>
        </AdaptativeGridContainer>
      </>
    </BasicModal>
  )
}

VisualizarPostagemModal.propTypes = {
  postagem: object,
  onChange: func
}
